<mat-icon class="decision-icon" (click)="handlePOPUP(data,header)">visibility</mat-icon>